<template>
  <footer :id="$options.name" class="mt-2 text-gray-500 text-xs text-center">
  </footer>
</template>

<script>
export default { name: 'notes-footer' }
</script>
